import React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Packages from '../components/Packages';
import AISection from '../components/AISection';
import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import ContactCTA from '../components/ContactCTA';
import SEO from '../components/SEO';
import { combineSchemas, organizationSchema, localBusinessSchema, websiteSchema } from '../lib/schema';

const HomePage = () => (
  <Layout>
    <SEO
      title="Website Symphony | Custom Web Design, A.I. & Marketing"
      description="Website Symphony builds custom, high-converting websites for med spas, tattoo shops, medical, legal and eCommerce brands across the U.S. AI-powered design, marketing and hosting. Free quote."
      canonical="/"
      schema={combineSchemas(organizationSchema, localBusinessSchema, websiteSchema)}
    />
    <Hero />
    <Intro />
    <Packages />
    <AISection />
    <Portfolio />
    <Testimonials />
    <Services />
    <ContactCTA defaultService="Home Page Estimate" />
  </Layout>
);

export default HomePage;
